import { render } from "./P051.vue?vue&type=template&id=4d22e3c0&scoped=true"
import script from "./P051.vue?vue&type=script&lang=js"
export * from "./P051.vue?vue&type=script&lang=js"

import "./P051.vue?vue&type=style&index=0&id=4d22e3c0&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d22e3c0"]])

export default __exports__